/**
 * components/landing/platform/PlatformPage.jsx — Phase 3 · the definitive
 * Kalki Ai Cloud Platform page.
 *
 * Composes 13 sections in narrative order (see /platform PRD):
 *
 *   3.1  Hero              — introduce the platform (not sell it)
 *   3.2  Philosophy        — broken ecosystem → unified platform
 *   3.3  Layers            — the 7 architecture layers
 *   3.4  Components        — 13 modules · Apple-style showcase
 *   3.5  DataFlow          — user journey through the platform
 *   3.6  White-Label Infra — 9-step deployment stack
 *   3.7  Business Ops      — revenue + ops backbone
 *   3.8  AI Engine         — how AI actually works
 *   3.9  Standards         — enterprise-grade
 *   3.10 Why Choose        — outcomes, not features
 *   3.11 Comparison        — vendor-neutral matrix
 *   3.12 FAQ               — practical answers
 *   3.13 Final CTA         — close the loop
 *
 * Every section lives in ./sections/*.jsx.  Design system primitives
 * from /components/landing/design-system + shared helpers from
 * /components/landing/home/_shared.jsx are reused so the whole vendor
 * site feels like one product family.
 */

import SiteFrame from '@/components/landing/SiteFrame'
import Hero            from './sections/Hero'
import Philosophy      from './sections/Philosophy'
import Layers          from './sections/Layers'
import Components      from './sections/Components'
import DataFlow        from './sections/DataFlow'
import WhiteLabelInfra from './sections/WhiteLabelInfra'
import BusinessOps     from './sections/BusinessOps'
import AIEngine        from './sections/AIEngine'
import Standards       from './sections/Standards'
import WhyChoose       from './sections/WhyChoose'
import Comparison      from './sections/Comparison'
import FAQ             from './sections/FAQ'
import FinalCTA        from './sections/FinalCTA'

const PlatformPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />              {/* 3.1  */}
    <Philosophy />        {/* 3.2  */}
    <Layers />            {/* 3.3  */}
    <Components />        {/* 3.4  */}
    <DataFlow />          {/* 3.5  */}
    <WhiteLabelInfra />   {/* 3.6  */}
    <BusinessOps />       {/* 3.7  */}
    <AIEngine />          {/* 3.8  */}
    <Standards />         {/* 3.9  */}
    <WhyChoose />         {/* 3.10 */}
    <Comparison />        {/* 3.11 */}
    <FAQ />               {/* 3.12 */}
    <FinalCTA />          {/* 3.13 */}
  </SiteFrame>
)

export default PlatformPage
